const initialState = {
	data: [],
	total: 0,
	params: {},
	selectedOnlinePlayer: {},
	sidebarOpen: false,
	sidebarStatus: 'add',
}

const onlineplayer = (state = initialState, action) => {
	switch (action.type) {
		case 'PLAYERONLINE_GET_DATA':
			return {
				...state,
				data: action.data,
				total: action.total,
				params: action.params,
			}
		case 'PLAYERONLINE_DEL_DATA':
			const data = state.data.filter((e) => e.id !== action.index)
			return { ...state, data, total: state.total - 1 }
		case 'PLAYERONLINE_ALL_DEL_DATA':
			return { state: initialState }
		case 'PLAYERONLINE_ADD_DATA':
			const addData = [...state.data, action.data]
			return Object.assign({ ...state, data: addData, total: state.total + 1 })
		case 'PLAYERONLINE_UPDATE_DATA':
			const index = state.data.findIndex((e) => e.id === action.index)
			const upateData = state.data
			upateData[index] = action.data
			return Object.assign({ ...state, data: [...upateData] })
		case 'PLAYERONLINE_GET_CURRENT':
			return { ...state, selectedOnlinePlayer: action.selectedOnlinePlayer }
		case 'PLAYERONLINE_SET_SIDEBAR':
			return {
				...state,
				sidebarStatus: action.status,
				sidebarOpen: !state.sidebarOpen,
			}
		default:
			return { ...state }
	}
}

export default onlineplayer
